import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import MatriculadosPage from 'sites/admin/cucicba/gestionarUsuarios/MatriculadosPage';
import Tutoriales from 'sites/admin/inmobiliario/ayuda/Tutoriales';
import EditRealEstate from 'sites/admin/inmobiliario/gestionarInmobiliaria/EditRealEstate';
import MisEstadisticas from 'sites/admin/inmobiliario/info/misEstadisticas/MisEstadisticas';
import Resumen from 'sites/admin/inmobiliario/info/resumen/Resumen';
import RealEstateIntegration from 'sites/admin/cucicba/integracionInmobiliarias/RealEstateIntegration';

const RoutesCucicba = () => {
  const token = localStorage.getItem('token_A');

  return (
    <>
      <Route path="/usuarios">
        <Route
          path="matriculados"
          element={
            token === null ? (
              <Navigate to={'/ingresar'} />
            ) : (
              <MatriculadosPage />
            )
          }
        />
      </Route>
      <Route path="/resumen">
        <Route
          path=""
          element={token === null ? <Navigate to={'/ingresar'} /> : <Resumen />}
        />
      </Route>
      <Route
        path="/estadisticas"
        element={
          token === null ? <Navigate to={'/ingresar'} /> : <MisEstadisticas />
        }
      />
      <Route path="/ayuda">
        <Route
          path="tutoriales"
          element={
            token === null ? <Navigate to={'/ingresar'} /> : <Tutoriales />
          }
        />
      </Route>

      <Route
        path="/admin/ver-inmobiliaria/:id"
        element={
          token === null ? <Navigate to={'/ingresar'} /> : <EditRealEstate />
        }
      />

      <Route
        path="/admin/inmobiliarias-integradas"
        element={
          token === null ? (
            <Navigate to={'/ingresar'} />
          ) : (
            <RealEstateIntegration />
          )
        }
      />
    </>
  );
};

export default RoutesCucicba;
